import * as React from "react";
import type { SVGProps } from "react";
const SvgVoucher = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#ff333f"
      d="M17 5h3c1.105 0 2 .978 2 2.184V10a2 2 0 1 0 0 4v2.816C22 18.022 21.105 19 20 19h-3zm-1 0H4c-1.105 0-2 .978-2 2.184V10a2 2 0 1 1 0 4v2.816C2 18.022 2.895 19 4 19h12z"
    />
    <path
      fill="#fff"
      d="M11.067 12.81c-.643-.242-1.152-.434-1.133-.916.017-.427.37-.648.992-.625.47.018.726.126.932.212.14.06.268.137.415.148.336.025.452-.234.603-.55.082-.17.068-.325-.078-.478-.094-.097-.38-.241-.599-.33-.282-.113-.668-.202-1.16-.22-.807-.03-1.483.145-1.955.505-.451.344-.702.84-.726 1.437-.053 1.316.999 1.722 1.844 2.048.65.25 1.211.468 1.19 1.008-.02.487-.426.752-1.115.726-.584-.022-.875-.15-1.087-.243-.134-.059-.263-.146-.404-.162-.34-.038-.447.282-.607.585-.105.202-.05.418.2.557.313.175.825.448 1.784.484.852.032 1.561-.15 2.052-.525.47-.36.732-.884.758-1.517.056-1.402-1.031-1.814-1.906-2.143M10.55 7a.425.425 0 0 0-.424.424v1.09a.424.424 0 1 0 .847 0v-1.09A.424.424 0 0 0 10.549 7M7.895 8.066A.42.42 0 0 0 7.3 7.98a.426.426 0 0 0-.085.594l.693.927a.42.42 0 0 0 .593.085.426.426 0 0 0 .085-.595zm-.927 2.857-1.12-.477a.423.423 0 0 0-.555.225.43.43 0 0 0 .224.558l1.12.477a.42.42 0 0 0 .323.003.426.426 0 0 0 .008-.786"
    />
  </svg>
);
export default SvgVoucher;
